/**
 * SOLID Review
 * S — Strong. One rule: which failure messages a player is shown, and what is shown instead.
 * O — Good. A new player-facing refusal code is one entry in the frozen table.
 * L — N/A — a function.
 * I — Strong. One export.
 * D — Strong. The Application's port vocabulary only.
 */
import { SERVER_REFUSED } from '../../application/ports/contracts';

/**
 * The codes whose message is WRITTEN FOR THE PLAYER (frontend strict-ports plan, FE3, 2026-10-03): the
 * Domain's refusals of a form — an address that is not one, a name, a table code no room has — and the
 * server's own words. Every other failure — `UNAVAILABLE`, the guard's `CONTRACT`, `INTERNAL`,
 * `DEADLINE` — is a diagnostic for the console, and the screen shows its own generic line instead. The
 * lobby (FE1) and the funnel (FE2) drew the same line, each in place; the auth screens share this one.
 */
const FOR_THE_PLAYER: readonly string[] = Object.freeze(['INVALID_INPUT', 'INVALID_NAME', 'NOT_FOUND', SERVER_REFUSED]);

export function messageFor(error: { readonly code: string; readonly message: string }, fallback: string): string {
  return FOR_THE_PLAYER.includes(error.code) ? error.message : fallback;
}
